import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { StatsBar } from '../components/sections/StatsBar';
import { AudiencePathwaysSection } from '../components/sections/AudiencePathwaysSection';
import { CategoryBrowseSection } from '../components/sections/CategoryBrowseSection';
import { FeaturedGuidesSection } from '../components/sections/FeaturedGuidesSection';
import { WhySection } from '../components/sections/WhySection';
import { HowEvaluationWorksSection } from '../components/sections/HowEvaluationWorksSection';
import { WhatWeAreNotSection } from '../components/sections/WhatWeAreNotSection';
import { WhoThisIsForSection } from '../components/sections/WhoThisIsForSection';
import { TransparencySection } from '../components/sections/TransparencySection';
import { CTASection } from '../components/sections/CTASection';
export function HomePage() {
  return <div className="bg-slate-50 text-slate-900 font-sans selection:bg-teal-100 selection:text-teal-900" data-id="element-406">
      <HeroSection data-id="element-407" />
      <StatsBar data-id="element-408" />
      <AudiencePathwaysSection data-id="element-409" />
      <CategoryBrowseSection data-id="element-410" />
      <FeaturedGuidesSection data-id="element-411" />
      <WhySection data-id="element-412" />
      <HowEvaluationWorksSection data-id="element-413" />
      <WhatWeAreNotSection data-id="element-414" />
      <TransparencySection data-id="element-415" />
      <WhoThisIsForSection data-id="element-416" />
      <CTASection data-id="element-417" />
    </div>;
}